
import moment from 'moment';
import {isEmpty, isNil} from 'lodash';

export const DateUtil = {
    DATE_FORMATS: {
        MONTH_DAY_YEAR: 'MM/DD/YYYY',
        DAY_MONTH_YEAR: 'DD-MMM-YYYY',
        YEAR_MONTH_DAY: 'YYYY-MM-DD',
        YEAR: 'YY',
        YEAR_FULL: 'YYYY',
        MONTH: 'M',
        MONTH_TWO_DIGITS: 'MM',
        MONTH_NAME: 'MMM',
        MONTH_NAME_FULL: 'MMMM',
        DAY: 'D',
        DAY_TWO_DIGITS: 'DD',
        YEAR_MONTH_DAY_TIME: 'YYYY-MM-DD HH:mm',
        DAY_HYPHEN_MONTH_NAME: 'D-MMM',
        MONTH_NAME_DAY: 'MMM D',
        MM_DD_YY: 'MMDDYY'
    },

    isMomentObj: data => moment.isMoment(data),
    formatUtcDate: function(dateObj, format) {
        const dateFormat = format || DateUtil.DATE_FORMATS.YEAR_MONTH_DAY;
        return moment.utc(dateObj).format(dateFormat);
    },
    formatDate: (dateString, dateFormat) => moment(dateString).format(dateFormat),
    getNowMoment: (dateString) => !isEmpty(dateString) || !isNil(dateString) ? moment(dateString) : new moment(),
    getClonnedNowMoment: (dateMoment) => !isEmpty(dateMoment) || !isNil(dateMoment) ? dateMoment.clone() : new moment().clone(),
    getMonth: dateObj => dateObj.month(),
    setMonth: (dateObj, numberOfMonths) => dateObj.month(numberOfMonths),
    isSameMoment: (nowMoment, compareMoment) => nowMoment.isSame(compareMoment),
    isBeforeMoment: (nowMoment, compareMoment) => nowMoment.isBefore(compareMoment),
    isAfterMoment: (nowMoment, compareMoment) => nowMoment.isAfter(compareMoment),
    isBetweenMoment: (nowMoment, compareStartMoment, compareEndMoment) => nowMoment.isBetween(compareStartMoment, compareEndMoment),
    addDaysInMoment: (nowMoment, numberOfDays) => nowMoment.add(numberOfDays, 'days'),
    subtractDaysInMoment: (nowMoment, numberOfDays) => nowMoment.subtract(numberOfDays, 'days'),
    addMonths: (nowMoment, numberOfMonths) => nowMoment.add(numberOfMonths, 'months'),
    subtractMonths: (nowMoment, numberOfMonths) => nowMoment.subtract(numberOfMonths, 'months'),
    difference: (dateObj1, dateObj2, unit) => DateUtil.getNowMoment(dateObj1).diff(DateUtil.getNowMoment(dateObj2), unit || 'days')
};
